import { useState } from 'react';
import { useIntl } from "react-intl";
import { Col, Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { CancelMotiveDTO } from '../../models/Generic/CancelMotiveDTO';
import { SchedulerService } from '../../services/SchedulerService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import useValidationSchema, { FieldConfig } from '../Validations';

export type CancelScheduleComponentProps = {
    scheduleId: number | null;

    onClose: () => void;
}

interface CancelScheduleDTO extends CancelMotiveDTO {
    scheduleId: number | null;
}

export default function CancelScheduleComponent(props: CancelScheduleComponentProps) {
    const intl = useIntl();
    const scheduleService = new SchedulerService();
    const [cancelMotive, setCancelMotive] = useState<CancelMotiveDTO | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    // Validações (campo, tipo dados, mensagem (pt.json))
    const fields: FieldConfig[] = [
        ["scheduleId", "number", "CancelReminderComponent.Validation.SchedulerIdRequired"],
        ["motive", "string", "CancelReminderComponent.Validation.MotiveRequired"]
    ];
    const schemaClientValidation = useValidationSchema(fields);

    const CancelSchedule = async () => {
        setIsLoading(true);

        const cancelSchedule: CancelScheduleDTO = {
            scheduleId: props.scheduleId,
            motive: cancelMotive?.motive ?? null
        };

        const { error } = schemaClientValidation.validate(cancelSchedule);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setIsLoading(false);
            return;
        }
        const response = await scheduleService.Cancel(props.scheduleId, cancelSchedule);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        Toast.Show("success", response.message);
        setIsLoading(false);

        props.onClose();
    };

    return (
        <div>
            <Row style={{ marginTop: "10px", paddingLeft: "13px", paddingBottom: "13px", paddingRight: "13px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={cancelMotive?.motive ?? ''}
                    label={intl.formatMessage({ id: "CancelScheduleComponent.Motive" })}
                    readOnly={false}
                    onChange={(motive: string) => {
                        setCancelMotive({
                            motive: motive
                        });
                    }}
                />
            </Row>

            <Row style={{ marginTop: "10px", paddingLeft: "13px", paddingBottom: "13px", paddingRight: "13px" }}>
                <Col xl={3} lg={3} md={3} sm={6} xs={6}>
                    <ButtonComponent
                        disabled={false}
                        loading={isLoading}
                        text={intl.formatMessage({ id: "CancelScheduleComponent.Button.Cancel" })}
                        onClick={CancelSchedule}
                        style={{ width: "100%" }}
                    />
                </Col>
            </Row>
        </div>
    );
}